import React, { useEffect, useState } from 'react';
import { BookUser, Loader2, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ewbInwardApi } from '@/services/ewayBillApi';

const SRC = { supplier: ['Saved supplier', 'bg-violet-100 text-violet-800'], jobber: ['Jobber Master', 'bg-teal-100 text-teal-800'] };

const Row = ({ p, onPick }) => {
  const [label, cls] = SRC[p.source] || [p.source, 'bg-gray-100 text-gray-700'];
  return (
    <button type="button" onClick={() => onPick(p)} className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm transition-colors hover:bg-violet-50"
      data-testid={`inward-party-opt-${p.ref}`}>
      <span className="font-semibold truncate">{p.name}</span>
      <span className={`shrink-0 rounded-full px-2 text-[10px] font-semibold ${cls}`}>{label}</span>
      <span className="ml-auto shrink-0 font-mono text-xs text-gray-500">{p.gstin || 'URP'}</span>
      <span className="shrink-0 text-xs text-gray-500">{[p.place, p.pincode].filter(Boolean).join(' – ')}</span>
    </button>
  );
};

/** Search saved suppliers and Jobber Master jobbers; picking one fills the sender. */
export const PartyPick = ({ onPick }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!open) return undefined;
    setRows(null);
    const t = setTimeout(() => ewbInwardApi.parties(q).then(setRows).catch(() => setRows([])), 250);
    return () => clearTimeout(t);
  }, [open, q]);
  if (!open) {
    return <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid="inward-party-pick-btn"><BookUser className="w-4 h-4 mr-1" />Pick saved supplier / jobber</Button>;
  }
  return (
    <div className="basis-full rounded-lg border border-violet-200 bg-white shadow-sm" data-testid="inward-party-pick">
      <div className="flex gap-2 p-2">
        <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, GSTIN or place" className="h-9" data-testid="inward-party-search" />
        <Button size="sm" variant="ghost" onClick={() => setOpen(false)} data-testid="inward-party-pick-close"><X className="w-4 h-4" /></Button>
      </div>
      <div className="max-h-56 overflow-y-auto divide-y border-t" data-testid="inward-party-list">
        {rows === null ? <Loader2 className="w-5 h-5 mx-auto my-4 animate-spin text-violet-600" />
          : rows.length === 0 ? <p className="py-4 text-center text-sm text-gray-500" data-testid="inward-party-empty">No saved supplier or jobber matches — type the details below</p>
            : rows.map((p) => <Row key={p.ref} p={p} onPick={(x) => { onPick(x); setOpen(false); }} />)}
      </div>
    </div>
  );
};

export default PartyPick;
